export default __webpack_public_path__ + "static/media/dms-logo-white.10c6fdf7.svg";